import { BUYABLE_FEE_POLICY } from '@fiverr-private/price_upfront_components';

export const STORAGE_KEY_SUFFIX = '_price_badge_was_seen';
export const MAX_DISPLAY_COUNT = 3;

export const feePolicyMessages = {
    [BUYABLE_FEE_POLICY.FEES]: 'shared.price_upfront.fees',
    [BUYABLE_FEE_POLICY.FEES_AND_TAX]: 'shared.price_upfront.taxes_and_fees',
    [BUYABLE_FEE_POLICY.FEES_WITHOUT_TAX]: 'shared.price_upfront.fees',
} as const satisfies Record<
    (typeof BUYABLE_FEE_POLICY)[keyof typeof BUYABLE_FEE_POLICY],
    'shared.price_upfront.fees' | 'shared.price_upfront.taxes_and_fees'
>;
